import { useDroppable } from '@dnd-kit/core'
import { flexRender, HeaderGroup } from '@tanstack/react-table'
import { TbArrowBarToDown, TbArrowDown } from 'react-icons/tb'

import clsx from 'clsx'
import React, { FC } from 'react'
import { IBreakRegistrationByDay } from '../../../../../../../models/events/event.interface'

interface OrderOfGoTableRiderHeaderProps {
  headerGroup: HeaderGroup<IBreakRegistrationByDay>
  isEditMode: boolean
  isDragging: boolean
}

export const OrderOfGoRiderTableHeader: FC<OrderOfGoTableRiderHeaderProps> = ({
  headerGroup,
  isEditMode,
  isDragging,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: 'out-of-turn-dropzone',
  })

  return (
    <tr
      key={headerGroup.id}
      ref={isEditMode && isDragging ? setNodeRef : undefined}
      className={clsx('relative transition-all duration-200', {
        'bg-blue-50 border-b-2 border-blue-200': isEditMode && isDragging && isOver,
        'bg-slate-50 border-b-2 border-slate-200': isEditMode && isDragging && !isOver,
        'border-b border-[#e9ecef]': !(isEditMode && isDragging),
      })}
    >
      {headerGroup.headers.map((header) => (
        <th key={header.id} className="pb-2">
          {!header.isPlaceholder && flexRender(header.column.columnDef.header, header.getContext())}
        </th>
      ))}

      {/* overlay drop zone when dragging */}
      {isEditMode && isDragging && (
        <td
          className={clsx(
            'absolute top-0 left-0 z-10 w-full flex items-center justify-center  transition-all duration-200',
            {
              'bg-blue-50 cursor-copy': isOver,
              'bg-slate-50 cursor-not-allowed': !isOver,
            }
          )}
        >
          <div
            className={clsx(
              'inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 transform',
              {
                'border-2 border-dashed border-blue-400 bg-blue-100 text-blue-800 scale-105 shadow-lg':
                  isOver,
                'border border-solid border-slate-300 bg-white text-slate-600 scale-100 shadow-sm':
                  !isOver,
              }
            )}
          >
            {isOver ? (
              <TbArrowBarToDown className="h-4 w-4" />
            ) : (
              <TbArrowDown className="animate-bounce h-4 w-4" />
            )}

            {isOver ? (
              <span className="font-semibold">Release to mark Out of Turn</span>
            ) : (
              <span>Drop to mark as Out of Turn</span>
            )}
          </div>
        </td>
      )}
    </tr>
  )
}
